import { render } from "./PortalPdfViewer.vue?vue&type=template&id=eb3cd38a&scoped=true"
import script from "./PortalPdfViewer.vue?vue&type=script&lang=js"
export * from "./PortalPdfViewer.vue?vue&type=script&lang=js"

import "./PortalPdfViewer.vue?vue&type=style&index=0&id=eb3cd38a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb3cd38a"]])

export default __exports__